import React from 'react';

import PageHeader from '@atlaskit/page-header';

import { Project } from '@qality/common-model';

import ReportBreadcrumbs from './ReportBreadcrumbs';
import './_report-header.scss';

type Props = {
  name: string;
  description: string;
  project: Project;
  actions: JSX.Element; // JSX Element for compatibility with PageHeader props
};

export default function ReportHeader({
  name,
  description,
  project,
  actions,
}: Props): JSX.Element {
  return (
    <header>
      <PageHeader
        actions={actions}
        breadcrumbs={project ? <ReportBreadcrumbs project={project} /> : null}
      >
        {name}
      </PageHeader>
      <b className='report-description-label'>Description:</b>
      <p className='report-description-text'>{description}</p>
    </header>
  );
}
